import React from 'react';
import ReactFlagsSelect from 'react-flags-select';
import moment from 'moment';
import { StyledContent } from '../../styles/mixins'
import { StyledPromocode, StyledOrderCard } from './style'
import { StyledCard } from '../user-profile/style'
import { Form, Input, Row, Col, Checkbox, message, Button, Modal } from 'antd';
import ReactMarkdown from 'react-markdown'
import ApiService from '../../actions/apiService';
import StripeForm from "./StripeForm";
import { Auth } from '../../services/auth'
const FormItem = Form.Item;
const { TextArea } = Input;

type State = {
  form: {
    firstName: string,
    lastName: string,
    billingAddress1: string,
    address2: string,
    city: string,
    state: string,
    zip: number,
    country: string,
    phone: number,
    cellphoneAlerts: number,
    email: string,
    password: string
  },
  error: string,
  success: string
}

const initialState: State = {
  form: {
    firstName: '',
    lastName: '',
    billingAddress1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    phone: '',
    cellphoneAlerts: '',
    email: '',
    password: '',
    promoCode:'',
  },
  error: '',
  success: '',
}


class Checkout extends React.Component {

  state: State = {
    form: {
      firstName: initialState.form.firstName,
      lastName: initialState.form.lastName,
      billingAddress1: initialState.form.billingAddress1,
      address2: initialState.form.address2,
      city: initialState.form.city,
      state: initialState.form.state,
      zip: initialState.form.zip,
      country: initialState.form.country,
      phone: initialState.form.phone,
      cellphoneAlerts: initialState.form.cellphoneAlerts,
      email: initialState.form.email,
      password: initialState.form.password,
      promoCode: initialState.form.promoCode
    },
    error: initialState.error,
    success: initialState.success,
    token: '',
    objData: null,
    auth: new Auth(),
    isLoading: true,
  }
  
  async componentWillMount() {
    this.getPrivacyPolicy();
    const checkOutPlan = this.props.location.state
    if (checkOutPlan && checkOutPlan.packageId) {
      this.setState({
        checkOutPlan: {
          ...checkOutPlan,
        }
      });
      if (checkOutPlan.promoCode) {
        this.onPromoCode(checkOutPlan.promoCode);
      } else if (checkOutPlan.packageId.toString() === '4') {
        this.onPromoCode('NewYearSpecial2019');
      }
    } else {
      this.props.history.push('/shop')
    }
  }
  
  getPrivacyPolicy = async () => {
    const response = await ApiService.getMethod('/pages/privacypolicy');
    if (response) {
      this.setState({
        privacyPolicyContent: response,
      });
    }
  }

  handleSubmit = (e: Object) => {
    if (e) {
      e.preventDefault()
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.submitPlan(values);
      }
    })
  }
  
  submitPlan = async (data) => {
    const {checkOutPlan, token} = this.state;
    const objData = {
      firstName: data.firstName,
      lastName: data.lastName,
      billingAddress1: data.billingAddress1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      zip: data.zip,
      country: data.country,
      phone: data.phone,
      cellphoneAlerts: data.cellphoneAlerts,
      email: data.email,
      password: data.password,
      promoCode: data.promoCode,
      plan: checkOutPlan,
      stripeToken: token,
      agreement: data.agreement,
    }
    this.setState({
      objData: JSON.stringify(objData)
    });
    try {
      await ApiService.postMethod('/purchases/createorder', objData);
      message.success('You have submitted successfully');
      if (!Auth.isAuthenticated()) {
        this.props.history.push('/welcome');
      }
    } catch(er) {
      message.error('Something went wrong!');
    }
  }

  checkForm = (cb, isToken) => {
    this.props.form.validateFields((err, values) => {
      if (cb) {
        cb(err, values)
      }
    })
  }

  checkCheckBox = (rule, value, callback) => {
    if (!value) {
      callback('Please agree the terms and conditions!');
    } else {
      callback();
    }
  };

  onToken = (token) => {
    this.setState({
      token,
    }, ()=> {
      this.handleSubmit();
    })
  }
  
  onPromoCode = async (promoCode) => {
    const response = await ApiService.getMethod(`/purchases/checkcoupon?couponCode=${promoCode}`);
    if (response && response.validCoupon) {
      this.setState({
        form: {
          ...this.state.form,
          promoCode: promoCode,
        },
        promoData: response,
      });
      message.success('promo code applied successfully!')
    } else {
      message.error('promo code not valid!');
      this.setState({
        promoData: null,
      })
      
    }
  }
  
  onApplyCode = () => {
    const promoCode = this.props.form.getFieldValue('promoCode');
    if (promoCode) {
      this.onPromoCode(promoCode);
    } else {
      this.setState({
        promoData: null,
      });
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    let { form, token, objData, promoData, checkOutPlan = {}} = this.state;
    let promoType = (promoData || {}).type;
    const packagePrice = checkOutPlan.price || 0;
    const isOneTime = checkOutPlan.planType === 'onetime';
    const totalPrice = () => {
      let price = packagePrice;
      if (promoType === 'AmountOff') {
        price = price - ((promoData.amountOff || 0) / 100);
      }
      if (promoType === 'PercentageOff') {
        price = (price * (promoData.percentageOff / 100));
      }
      if (promoType === 'FreeTrial' || promoType === 'FreeTrialNoCC') {
       return `${promoData.freeTrialDays} Days Free Trial`;
      }
      return `$ ${price && parseFloat(price).toFixed(2)}/-`;
    };
    const nextBillingDate = () => {
      let nextDate = moment();
      if (checkOutPlan.planLength === 'Month') {
        nextDate = moment().add(1, 'month');
      }
      if (checkOutPlan.planLength === 'Year') {
        nextDate = moment().add(1, 'year');
      }
      if (promoType === 'FreeTrial' || promoType === 'FreeTrialNoCC') {
          nextDate = nextDate.add(promoData.freeTrialDays || 0, 'days');
      }
      return nextDate.format('YYYY-MM-DD');
    };
    const nextBillingPrice = () => {
      let nextPrice = packagePrice;
      let isOff = false;
      if (checkOutPlan.planLength === 'Month' && (!checkOutPlan.durationInMonths || checkOutPlan.durationInMonths  > 1)) {
        isOff = true;
      }
      if (checkOutPlan.planLength === 'Year' && (!checkOutPlan.durationInMonths || checkOutPlan.durationInMonths) > 12) {
        isOff = true;
      }
      if (isOff) {
        if (promoType === 'AmountOff') {
          nextPrice = nextPrice - ((promoData.amountOff || 0) / 100);
        }
        if (promoType === 'PercentageOff') {
          nextPrice = (nextPrice * (promoData.percentageOff / 100));
        }
      }
      return `$ ${nextPrice && parseFloat(nextPrice).toFixed(2)}/-`;
    }
    
    const isTrial = promoType === 'FreeTrialNoCC';
    const isLoggedIn = Auth.isAuthenticated();
    
    return (
      <StyledContent>
        <StyledCard title="Billing Details"  bordered={false}>
          <Row gutter={16}>
            {
              !isLoggedIn &&
              <Col span={16}>
                <Form layout={'vertical'} onSubmit={this.handleSubmit}>
                  <FormItem label="First Name">
                    {getFieldDecorator('firstName', {
                      initialValue: form.firstName,
                      rules: [{
                        required: true,
                        message: 'Please input your first name!',
                        whitespace: true
                      }],
                    })(
                      <Input placeholder="Input first name"/>
                    )}
                  </FormItem>
                  <FormItem label="Last Name">
                    {getFieldDecorator('lastName', {
                      initialValue: form.lastName,
                      rules: [{
                        required: true,
                        message: 'Please input your last name!',
                        whitespace: true
                      }],
                    })(
                      <Input placeholder="Input Last Name "/>
                    )}
                  </FormItem>
    
                  <FormItem label="Billing Address 1">
                    {getFieldDecorator('billingAddress1', {
                      initialValue: form.billingAddress1,
                      rules: [{
                        required: !isTrial,
                        message: 'Please input your billing address 1!',
                        whitespace: true
                      }],
                    })(
                      <TextArea placeholder="Input billing address 1" autosize={{maxRows: 3}}/>
                    )}
                  </FormItem>
    
                  <FormItem label="Billing Address 2">
                    {getFieldDecorator('address2', {
                      initialValue: form.address2,
                      rules: [{
                        message: 'Please input your billing address 2!',
                        whitespace: true
                      }],
                    })(
                      <TextArea placeholder="Input billing address 2" autosize={{maxRows: 3}}/>
                    )}
                  </FormItem>
    
                  <Row gutter={16}>
                    <Col span={8}>
                      <FormItem label="City">
                        {getFieldDecorator('city', {
                          initialValue: form.city,
                          rules: [{
                            required: !isTrial,
                            message: 'Please input your city name!',
                            whitespace: true
                          }],
                        })(
                          <Input placeholder="Input city name"/>
                        )}
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem label="State">
                        {getFieldDecorator('state', {
                          initialValue: form.state,
                          rules: [{
                            required: !isTrial,
                            message: 'Please input your state name!',
                            whitespace: true
                          }],
                        })(
                          <Input placeholder="Input state name"/>
                        )}
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem label="Zip">
                        {getFieldDecorator('zip', {
                          initialValue: form.zip,
                          rules: [
                            {
                              pattern: '^(0|[1-9][0-9]*)$',
                              message: 'Please input only numbers values!',
                            }, {
                              required: !isTrial,
                              message: 'Please input your zip code!',
                              whitespace: true
                            }],
                        })(
                          <Input placeholder="Input zip code"/>
                        )}
                      </FormItem>
                    </Col>
                  </Row>
    
                  <Row gutter={16}>
                    <Col sm={24} xs={24}>
                      <FormItem label="Cell Phone for Text Alerts">
                        {getFieldDecorator('cellphoneAlerts', {
                          initialValue: form.cellphoneAlerts,
                          rules: [{
                            pattern: '^(0|[1-9][0-9]*)$',
                            message: 'Please input only numbers values!',
                          }]
                        })(<Input placeholder="Input cell phone number"/>)}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col sm={12} xs={24}>
                      <FormItem label="Select your country">
                        <ReactFlagsSelect searchable ref={(flag => this.flag = flag)} />
                      </FormItem>
                    </Col>
                    <Col sm={12} xs={24}>
                      <FormItem
                        label="Phone">
                        {getFieldDecorator('phone', {
                          initialValue: form.phone,
                          rules: [{
                            pattern: '^(0|[1-9][0-9]*)$',
                            message: 'Please input only numbers values!',
                          }, {
                            required: !isTrial,
                            message: 'Please input your phone number!',
                            whitespace: true
                          }],
                        })(
                          <Input placeholder="Input phone number"/>
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  {!Auth.isAuthenticated() &&
                  <Row gutter={16}>
                    <Col sm={12} xs={24}>
                      <FormItem label="Email">
                        {getFieldDecorator('email', {
                          initialValue: form.email,
                          rules: [{
                            type: 'email',
                            message: 'The input is not valid e-mail!',
                          }, {
                            required: true,
                            message: 'Please input your e-mail!',
                          }],
                        })(
                          <Input placeholder="Input email"/>
                        )}
                      </FormItem>
                    </Col>
                    <Col sm={12} xs={24}>
                      <FormItem
                        label="Password">
                        {getFieldDecorator('password', {
                          initialValue: form.password,
                          rules: [{
                            required: !isTrial,
                            message: 'Please input your password!',
                            whitespace: true
                          }],
                        })(
                          <Input type="password" placeholder="Input password"/>
                        )}
                      </FormItem>
                    </Col>
                  </Row>}
  
                </Form>
              </Col>
            }
            <Col span={8}>
              <StyledOrderCard title="Order Details">
                <div className="line-header">
                  <Row>
                    <Col span={16} >
                      Product
                    </Col>
                    <Col span={8}>
                      Amount
                    </Col>
                  </Row>
                </div>

                <div className="line">
                  <Row>
                    <Col span={16}>
                      {checkOutPlan.packageName}
                    </Col>
                    <Col span={8} >
                      <span className="text-primary">{promoType === 'FreeTrialNoCC' ? 'Free' : `$${checkOutPlan.price}/-`}</span>
                    </Col>
                  </Row>
                </div>
                {
                  promoType === 'PercentageOff' &&
                  <div className="line">
                    <Row>
                      <Col span={16}>
                        Percent Off ({promoData.percentageOff}%)
                      </Col>
                      <Col span={8} >
                        <span className="text-primary">-${packagePrice - (packagePrice * (promoData.percentageOff / 100))}</span>
                      </Col>
                    </Row>
                  </div>
                }
                {
                  promoType === 'AmountOff' &&
                  <div className="line">
                    <Row>
                      <Col span={16}>
                        Amount Off
                      </Col>
                      <Col span={8} >
                        <span className="text-primary">-${(promoData.amountOff || 0)/ 100}</span>
                      </Col>
                    </Row>
                  </div>
                }
                <div className="line">
                  <Row>
                    <Col span={16}>
                      <b>Total</b>
                    </Col>
                    <Col span={8} className="text-primary">
                      <b>{totalPrice()}</b>
                    </Col>
                  </Row>
                </div>
                {
                  promoData &&
                  <div className="line">
                    <Row>
                      <Col span={24}>
                        {promoData.checkOutDescription}
                      </Col>
                    </Row>
                  </div>
                }
                {
                  promoType !== 'FreeTrialNoCC' && !isOneTime &&
                    <React.Fragment>
                      <div className="line">
                        <Row>
                          <Col span={16}>
                            <b>Next Bill Date</b>
                          </Col>
                          <Col span={8} className="text-primary">
                            <b>{nextBillingDate()}</b>
                          </Col>
                        </Row>
                      </div>
                      <div className="line">
                        <Row>
                          <Col span={16}>
                            <b>Next Bill Price</b>
                          </Col>
                          <Col span={8} className="text-primary">
                            <b>{nextBillingPrice()}</b>
                          </Col>
                        </Row>
                      </div>
                    </React.Fragment>
                }
                <StyledPromocode type="inner" title="Promo code">
                  <Row gutter={8}>
                    <Col span={18}>
                      {getFieldDecorator('promoCode', {
                        initialValue: form.promoCode,
                        rules: [{
                          message: 'Please input promo code!',
                        }, {}],
                      })(
                        <Input placeholder="Input promo code"/>
                      )}
                    </Col>
                    <Col span={6}>
                      <Button type="primary" onClick={this.onApplyCode}>Apply</Button>
                    </Col>
                  </Row>
                </StyledPromocode>&nbsp;
                {
                  promoType !== 'FreeTrialNoCC' && <StripeForm onToken={this.onToken} token={token} checkForm={this.checkForm}/>
                }
                <FormItem>
                  {getFieldDecorator('agreement', {
                    valuePropName: 'checked',
                    rules: [{
                      validator: this.checkCheckBox,
                      required: true,
                    }]
                  })(
                    <Checkbox>I agree with the <a style={{color: '#007bff'}} onClick={() => this.setState({visible: true,})}>Terms and Privacy Policy</a></Checkbox>
                  )}
                </FormItem>
                {
                  promoType === 'FreeTrialNoCC' && <Button type="primary" className="btn-con" onClick={this.handleSubmit}>Submit</Button>
                }
              </StyledOrderCard>
            </Col>
          </Row>
          {/*{
            objData &&
            <Row>
              <Col sm={24}>
                <TextArea rows={6} value={objData && JSON.stringify(objData)}/>
              </Col>
            </Row>
          }*/}
          
        </StyledCard>
        <Modal title="Terms and Privacy Policy"
               visible={this.state.visible}
               footer={null}
               style={{width: 600}}
               onCancel={() => this.setState({visible: false})}
          >
          <ReactMarkdown source={this.state.privacyPolicyContent || ''}/>
        </Modal>
      </StyledContent>
    );
  }
}

const StripeCheckoutForm = Form.create()(Checkout);
export default StripeCheckoutForm



// WEBPACK FOOTER //
// ./src/components/shop-pages/checkout.js